(function () {
'use strict';
var d = document, W = window;
var root = d.querySelector('[data-v5]');
if (!root) return;
var STAGE_Q = '(min-width: 1000px) and (min-height: 740px)';
var MAX_PLAYING = 2;
function $(s, r) { return (r || root).querySelector(s); }
function $$(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }
function mq(q) { return !!(W.matchMedia && W.matchMedia(q).matches); }
function motionOk() { return typeof W.sdMotionAllowed === 'function' ? W.sdMotionAllowed() : !mq('(prefers-reduced-motion: reduce)'); }
/* one broken part must never stop the others */
function guard(name, fn) { try { fn(); } catch (e) { try { if (W.console && W.console.warn) W.console.warn('vrx5 ' + name, e); } catch (e2) {} } }
/* "page ready": after the window load event (plus a beat), or after 6 s on a slow connection */
var pageReady = d.readyState === 'complete', readyQ = [];
function onReady(fn) { if (pageReady) fn(); else readyQ.push(fn); }
function fireReady() { if (pageReady) return; pageReady = true; readyQ.splice(0).forEach(function (f) { guard('ready', f); }); }
if (!pageReady) { W.addEventListener('load', function () { setTimeout(fireReady, 300); }); setTimeout(fireReady, 6000); }
/* ---------- videos: lazy, muted loops with posters, at most two playing, paused out of view and in a hidden tab ---------- */
guard('videos', function () {
var videos = $$('video[data-v5-video]');
if (!videos.length) return;
var paused = false, visible = [];
function loadVideo(v) {
if (v.dataset.loaded) return;
v.dataset.loaded = '1';
$$('source[data-src]', v).forEach(function (s) { s.src = s.getAttribute('data-src'); });
v.load();
}
function playVideo(v) {
if (paused || d.hidden || v.dataset.failed || !motionOk()) return;
var p; try { p = v.play(); } catch (e) {}
if (p && p.catch) p.catch(function () {});
}
function settle() {
visible.forEach(function (v, i) {
if (i >= visible.length - MAX_PLAYING) { if (v.dataset.loaded) playVideo(v); } else { v.pause(); }
});
}
videos.forEach(function (v) {
v.removeAttribute('autoplay');
v.addEventListener('error', function () { v.dataset.failed = '1'; try { v.pause(); } catch (e) {} }, true);
});
if (!motionOk()) { videos.forEach(function (v) { v.pause(); }); return; }
if ('IntersectionObserver' in W) {
var vio = new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
var v = e.target, i = visible.indexOf(v);
if (e.isIntersecting) {
if (i < 0) visible.push(v);
onReady(function () { if (visible.indexOf(v) < 0) return; loadVideo(v); settle(); });
} else {
if (i >= 0) visible.splice(i, 1);
v.pause();
}
});
settle();
}, { rootMargin: '200px 0px' });
videos.forEach(function (v) { vio.observe(v); });
} else {
onReady(function () { videos.slice(0, MAX_PLAYING).forEach(function (v) { loadVideo(v); playVideo(v); }); });
}
d.addEventListener('visibilitychange', function () {
if (d.hidden) videos.forEach(function (v) { v.pause(); }); else settle();
});
var pb = $('[data-v5-pause]');
if (pb) {
pb.hidden = false;
pb.addEventListener('click', function () {
paused = !paused;
pb.setAttribute('aria-pressed', String(paused));
pb.textContent = paused ? 'Play motion' : 'Pause motion';
if (paused) videos.forEach(function (v) { v.pause(); }); else settle();
});
}
});
/* ---------- in-page nav: current section ---------- */
guard('nav', function () {
var links = $$('[data-v5-link]');
if (!links.length || !('IntersectionObserver' in W)) return;
var map = {};
links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
var box = links[0].parentElement, hero = $('.v5-hero');
/* keep the current link in view inside the scrolling link row (measured from the row, not from the page) */
function showLink(a) {
if (!box || box.scrollWidth <= box.clientWidth) return;
box.scrollLeft = a ? Math.max(0, a.getBoundingClientRect().left - box.getBoundingClientRect().left + box.scrollLeft - 24) : 0;
}
var nio = new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
if (!e.isIntersecting) return;
links.forEach(function (a) { a.removeAttribute('aria-current'); });
var a = map[e.target.id];
if (a) a.setAttribute('aria-current', 'true');
if (a || e.target === hero) showLink(a);
});
}, { rootMargin: '-45% 0px -50% 0px' });
Object.keys(map).forEach(function (id) { var s = d.getElementById(id); if (s) nio.observe(s); });
if (hero) nio.observe(hero);
var qs = d.getElementById('v5-quote'); if (qs) { map['v5-quote'] = null; nio.observe(qs); }
});
/* ---------- quote form: pick a level or system from any button ---------- */
guard('form', function () {
var form = d.getElementById('VrxProjectForm');
$$('[data-v5-pick]').forEach(function (a) {
a.addEventListener('click', function () {
if (!form) return;
var lvl = a.getAttribute('data-v5-pick');
var sel = form.querySelector('select[name="contact[level]"]');
if (sel && lvl && sel.querySelector('option[value="' + lvl + '"]')) sel.value = lvl;
});
});
var thanks = d.getElementById('VrxQuoteThanks');
if (thanks) { setTimeout(function () { try { thanks.focus({ preventScroll: true }); } catch (e) {} }, 400); }
});
/* ---------- rails: previous / next ---------- */
guard('rails', function () {
$$('[data-v5-railbtn]').forEach(function (b) {
b.addEventListener('click', function () {
var rail = d.getElementById(b.getAttribute('data-v5-rail'));
if (!rail) return;
var step = Math.max(240, Math.round(rail.clientWidth * 0.8)) * (b.getAttribute('data-v5-railbtn') === 'next' ? 1 : -1);
rail.scrollBy({ left: step, behavior: motionOk() ? 'smooth' : 'auto' });
});
});
});
/* ---------- lightbox: shows the small picture at once, swaps in the large one, cleans up on close ---------- */
guard('lightbox', function () {
var lb = $('[data-v5-lb]');
var zooms = $$('[data-v5-zoom]');
if (lb && typeof lb.showModal === 'function') {
var lbImg = $('img', lb), lbCap = $('[data-v5-lb-cap]', lb), lastFocus = null, token = 0, pending = null;
function dropPending() { token++; if (pending) { pending.onload = pending.onerror = null; pending = null; } }
zooms.forEach(function (b) {
b.addEventListener('click', function () {
if (lb.open) return;
dropPending();
var t = token, full = b.getAttribute('data-full'), alt = b.getAttribute('data-alt') || '', th = $('img', b);
lastFocus = b;
lbImg.alt = alt; lbCap.textContent = alt;
lbImg.src = (th && (th.currentSrc || th.src)) || full;
lb.showModal();
pending = new Image();
pending.onload = function () { if (t === token) lbImg.src = full; pending = null; };
pending.onerror = function () { pending = null; };
pending.src = full;
});
});
$('[data-v5-lb-close]', lb).addEventListener('click', function () { lb.close(); });
lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
lb.addEventListener('close', function () { dropPending(); lbImg.removeAttribute('src'); if (lastFocus) { try { lastFocus.focus(); } catch (e) {} } });
} else {
zooms.forEach(function (b) { b.addEventListener('click', function () { W.open(b.getAttribute('data-full'), '_blank', 'noopener'); }); });
}
});
/* ---------- motion: hero still entrance, pinned stages ---------- */
function motion(ctx) {
var gsap = ctx.gsap, ST = ctx.ScrollTrigger;
var still = $('.v5-hero__still');
if (still) gsap.fromTo(still, { opacity: 0, x: 40 }, { opacity: 1, x: 0, duration: 1.1, ease: 'power3.out', clearProps: 'opacity,transform' });
var GEST = { heave: { y: -12 }, pitch: { rotation: -2.5 }, roll: { rotation: 2.5 } };
var stages = $$('[data-v5-stage]').map(function (w) { return { wrap: w, st: null }; });
/* make the pinned frame fit the window: shrink the big picture, or give up pinning (flat layout) */
function fitStage(wrap) {
var f = $('.v5-frame', wrap), c = f && f.firstElementChild, pl = $('.v5-plate--stage', wrap);
wrap.classList.remove('is-fit'); wrap.style.removeProperty('--v5-ph');
if (!f || !c) return true;
var over = c.getBoundingClientRect().height - f.clientHeight;
if (over <= 1) return true;
if (!pl) return false;
var target = pl.getBoundingClientRect().height - over - 6;
if (target < 260) return false;
wrap.style.setProperty('--v5-ph', Math.floor(target) + 'px');
wrap.classList.add('is-fit');
over = c.getBoundingClientRect().height - f.clientHeight;
if (over > 1) { wrap.classList.remove('is-fit'); wrap.style.removeProperty('--v5-ph'); return false; }
return true;
}
function flat(wrap) {
wrap.classList.remove('is-pinned', 'is-fit');
wrap.style.removeProperty('--v5-len'); wrap.style.removeProperty('--v5-ph');
}
function unpin(s) {
if (s.st) { s.st.kill(); s.st = null; }
$$('[data-v5-gesture]', s.wrap).forEach(function (g) { gsap.killTweensOf(g); gsap.set(g, { clearProps: 'all' }); });
flat(s.wrap);
}
function pin(s, force) {
var wrap = s.wrap, items = $$('[data-v5-item]', wrap), panels = $$('[data-v5-panel]', wrap);
if (s.st || items.length < 2 || !mq(STAGE_Q)) return false;
if (!force && wrap.getBoundingClientRect().top < W.innerHeight) return false;
var n = items.length;
wrap.style.setProperty('--v5-len', String(Math.round(60 + n * 70)));
wrap.classList.add('is-pinned');
if (!fitStage(wrap)) { flat(wrap); return false; }
var bar = $('[data-v5-bar]', wrap), cur = -1;
function setActive(i) {
if (i === cur) return;
cur = i;
items.forEach(function (el, k) { if (k === i) el.setAttribute('data-active', ''); else el.removeAttribute('data-active'); });
panels.forEach(function (el, k) { if (k === i) el.setAttribute('data-active', ''); else el.removeAttribute('data-active'); });
$$('[data-v5-chip]', wrap).forEach(function (c) { if (c.getAttribute('data-v5-chip') === items[i].getAttribute('data-v5-name')) c.setAttribute('data-lit', ''); else c.removeAttribute('data-lit'); });
var g = GEST[items[i].getAttribute('data-v5-name')];
var gimg = panels[i] ? panels[i].querySelector('[data-v5-gesture]') : null;
if (g && gimg) {
gsap.killTweensOf(gimg);
gsap.set(gimg, { transformOrigin: '50% 88%' });
gsap.to(gimg, Object.assign({ duration: 0.45, yoyo: true, repeat: 1, ease: 'sine.inOut' }, g));
}
}
setActive(0);
s.st = ST.create({
trigger: wrap,
start: function () { return 'top top+=' + ((parseFloat(getComputedStyle(d.documentElement).getPropertyValue('--sd-v4-hdr')) || 0) + 52); },
end: 'bottom bottom',
invalidateOnRefresh: true,
onUpdate: function (self) {
var i = Math.min(n - 1, Math.floor(self.progress * n * 0.999));
setActive(i);
if (bar) bar.style.transform = 'scaleX(' + self.progress.toFixed(3) + ')';
}
});
return true;
}
stages.forEach(function (s) { guard('stage', function () { pin(s); }); });
/* what the visitor is looking at (the scene and how far through it, or the element at the middle of the window),
   noted while they scroll, so a resize or zoom, which moves the page before any script runs, can put them back */
var place = null, frozen = false, nt = 0;
function notePlace() {
if (frozen) return;
var mid = W.innerHeight / 2, i, r, list, el;
place = null;
for (i = 0; i < stages.length; i++) {
r = stages[i].wrap.getBoundingClientRect();
if (r.top <= mid && r.bottom > mid && r.height > 0) { place = { wrap: stages[i].wrap, f: (mid - r.top) / r.height }; return; }
}
list = d.elementsFromPoint ? d.elementsFromPoint(W.innerWidth / 2, mid) : [];
for (i = 0; i < list.length; i++) {
el = list[i];
if (el === root || !root.contains(el) || el.querySelector('[data-v5-stage]')) continue;
r = el.getBoundingClientRect();
if (!r.height) continue;
place = { el: el, off: r.top - mid };
return;
}
}
function restorePlace() {
if (!place) return;
var mid = W.innerHeight / 2, r, y = null;
if (place.wrap) { r = place.wrap.getBoundingClientRect(); y = W.pageYOffset + r.top + place.f * r.height - mid; }
else if (d.documentElement.contains(place.el)) { r = place.el.getBoundingClientRect(); if (r.height) y = W.pageYOffset + r.top - (mid + place.off); }
if (y === null) return;
y = Math.max(0, Math.round(y));
if (Math.abs(y - W.pageYOffset) < 2) return;
try { W.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { W.scrollTo(0, y); }
}
W.addEventListener('scroll', function () { if (!frozen && !nt) nt = setTimeout(function () { nt = 0; guard('place', notePlace); }, 120); }, { passive: true });
/* window resized, zoomed, rotated or devtools opened: re-fit, flatten or pin again, and keep the visitor where they were */
function relayout(fromResize) {
var resized = fromResize === true;
if (frozen && !resized) return;
try {
if (!resized) guard('place', notePlace);
var changed = false;
stages.forEach(function (s) {
guard('relayout', function () {
if (s.st) {
if (!mq(STAGE_Q) || !fitStage(s.wrap)) unpin(s);
changed = true;
} else if (pin(s, resized)) { changed = true; }
});
});
/* put the visitor back first: ScrollTrigger remembers the scroll position it sees when it refreshes */
if (changed || resized) restorePlace();
if (changed) ST.refresh();
} finally {
frozen = false;
guard('place', notePlace);
}
}
var rt = 0;
W.addEventListener('resize', function () { frozen = true; clearTimeout(rt); rt = setTimeout(function () { relayout(true); }, 250); }, { passive: true });
guard('place', notePlace);
function afterLoad() { setTimeout(function () { relayout(); ST.refresh(); }, 200); }
if (d.readyState === 'complete') afterLoad(); else W.addEventListener('load', afterLoad);
if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { guard('fonts', relayout); });
}
function startMotion() {
if (!W.sdMotionReady) return;
W.sdMotionReady.then(function (ctx) {
if (!ctx || !motionOk()) return;
guard('motion', function () { motion(ctx); });
}, function () {});
}
if (W.sdMotionReady) startMotion(); else d.addEventListener('DOMContentLoaded', startMotion);
})();
